import Image from 'next/image';
import React, { CSSProperties } from 'react';

export const VelocityLogo = ({ alt = 'Earn Velocity Points', style }: { alt?: string; style?: CSSProperties | undefined } = {}) => (
    <Image style={{ ...style }} src="/assets/images/velocity/velocity_logo.svg" alt={alt} width={130} height={48} />
);
